module.exports = __webpack_public_path__ + "img/download.d582ec2b.svg";